import PageTabNavigation, { PageTabItem } from 'src/shared/components/navigations/pageTabNavigation';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';

export const MemberProfileTabNavigation = () => {
  const pageTabs: PageTabItem[] = [
    {
      label: 'memberProfile:tabNavigation.profileGroup',
      route: RoutesEnum.MemberProfileGroup,
    },
  ];

  return <PageTabNavigation pageTabs={pageTabs} />;
};
